import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { Observable } from 'rxjs/Observable';
import { map, tap, catchError } from 'rxjs/operators';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { FormatUtils } from '../../shared/_utils/services/formatUtils';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { Afp } from '../entities/afp';
import { Vars } from '../model/vars';
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { InterfaceAfp } from '../entities/interface-afp';
import * as FileSaver from 'file-saver';

@Injectable()
export class AfpService extends BaseCrudService<Afp> {

  public uri = '/api/afp/';

  constructor(injector: Injector) {
    super(injector);
    //console.log('Instance AfpService');
  }

  buildSentence(entity?: Afp, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = entity.code ? 'code'
        + QueryOperator.Contain + entity.code
        + QueryOperator.Split : QueryOperator.Empty;
      query = query.concat(
        entity.name ? 'name'
          + QueryOperator.Contain + entity.name
          + QueryOperator.Split : QueryOperator.Empty
      );
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

  getSequenceCode(): Observable<string> {
    const url = this.rutaServidor + this.uri + 'maxCode/';
    return this.httpClient.get<any>(url)
      .pipe(
        map(response => {
          // debugger;
          const code = response.maxCode ? response.maxCode : FormatUtils.padLeftZero(0, 3);
          const sequence = (parseInt(code, 10)) + 1;
          return FormatUtils.padLeftZero(sequence, 3);
        }),
        tap(response => {
          //console.log(response);
        })
      );
  }

  searchAfpNet(   fiscalYear: any, executingUnit: any, month: any,
    employeeType: any, payrollType, afp: any, employee: any,
    object: Vars): Observable<ResponsePageable<InterfaceAfp>> {
      const params = new HttpParams()
        .set('fiscalYearId', fiscalYear)
        .set('euId', executingUnit)
        .set('monthId', month)
        .set('employeeTypeId', employeeType)
        .set('payrollTypeId', payrollType)
        .set('afpId', afp)
        .set('employeeId', employee)
        this.spinnerService.showAll();
        const url = `${this.rutaServidor}${this.uri}searchAfpNet`;
        return this.httpClient.post<ResponsePageable<InterfaceAfp>>(url, object, {params}, )
        .pipe(
          tap(response => {
            this.spinnerService.hideAll();
            //console.log(response)
            return response;
          })
       );
    }

    fileGenerationAfp(filname: String): Observable<any> {
      const url = `${this.rutaServidor}${this.uri}interfaceAfp`;
      this.spinnerService.showAll();
      return this.httpClient.get(url, {responseType: 'blob'} )
      .pipe(
          map(res =>  {
            this.spinnerService.hideAll();
            let bean = new Blob([res], { type: 'application/txt'});
                  FileSaver.saveAs(bean, filname);
                  return bean;
              }
          ),
          catchError((err, caught) => {
              let resp = 'No se encontraron registros';
              this.spinnerService.hideAll();
              if (err.status == 404)
              this.notificationService.smallBoxWarning('Ventana de Alerta!', resp);
              return new Observable<Blob>();
              }
          )
      );
  }

  fileGenerationAfpList(): Observable<any> {
    const url = `${this.rutaServidor}${this.uri}interfaceAfpList`;
    this.spinnerService.showAll();
    return this.httpClient.post<InterfaceAfp>(url, undefined)
      .pipe(
        tap(response => {
          this.spinnerService.hideAll();
          // console.log(response)
          return response;
        })
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/afp.service.ts